import React from 'react';
import {
  FormControl,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  Box,
  Typography,
  Checkbox,
} from '@mui/material';

export default function StyledFormControlRadioGroup({
  sx = {},
  error = false,
  helperText = '',
  label,
  options = [],
  name,
  value,
  onChange,
  isPrimaryBorder = false,
  focusBorderPrimary = false,
  shape = 'round', // "round" o "square"
}) {
  const theme = useTheme();

  const borderColorDefault = isPrimaryBorder ? theme.primary : theme.tertiary;

  const borderColorHover = isPrimaryBorder ? theme.tertiary : theme.primary;

  const borderFocus = focusBorderPrimary ? theme.primary : borderColorHover;

  const renderControl = (shape, optionValue) => {
    if (shape === 'square') {
      return (
        <Checkbox
          checked={value === optionValue}
          onChange={() => onChange(optionValue)}
          sx={{
            borderRadius: 0,
            width: 20,
            height: 20,
            padding: 0,
            mr: 1,
            color: theme.tertiary,
            '&.Mui-checked': {
              color: theme.tertiary,
            },
          }}
        />
      );
    }

    return (
      <Radio
        sx={{
          p: 0.5,
          '& .MuiSvgIcon-root': {
            borderRadius: 50,
            fontSize: '20px',
          },
          color: theme.tertiary,
          '&.Mui-checked': {
            color: theme.tertiary,
          },
        }}
      />
    );
  };

  return (
    <Box id={name} sx={{ position: 'relative', width: '100%', ...(sx || {}) }}>
      {label && (
        <Typography
          variant="caption"
          sx={{
            position: 'absolute',
            top: '-14px',
            left: '0px',
            px: '8px',
            bgcolor: '#fff',
            zIndex: 1,
            fontSize: '16px',
            transform: 'scale(0.75)',
            color: error ? theme.palette.error.main : theme.tertiary,
            transition: 'color 0.2s',
            pointerEvents: 'none',
          }}
        >
          {label}
        </Typography>
      )}

      <FormControl
        component="fieldset"
        sx={{
          width: '100%',
          height: '45px',
          borderRadius: '8px',
          border: `1px solid ${borderColorDefault}`,
          padding: '0 12px',
          display: 'flex',
          justifyContent: 'center',
          boxSizing: 'border-box',
          transition: 'border-color 0.2s',
          '&:hover': {
            borderColor: borderColorHover,
          },
          '&:focus-within': {
            borderColor: borderFocus,
            borderWidth: focusBorderPrimary ? '2px' : '1px',
          },
        }}
        error={error}
      >
        <RadioGroup
          row={true}
          name={name}
          value={value}
          onChange={onChange}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            width: '100%',
            m: 0,
          }}
        >
          {options.map(option => (
            <FormControlLabel
              key={option?.value}
              value={option?.value}
              label={option?.label}
              sx={{
                margin: 0,
                '& .MuiFormControlLabel-label': {
                  color: 'black',
                  fontSize: '16px',
                },
              }}
              control={renderControl(shape, option?.value)}
            />
          ))}
        </RadioGroup>
      </FormControl>

      {error && helperText && (
        <FormHelperText sx={{ mt: 0.5, ml: 1, fontSize: '0.75rem' }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
}
